module.exports = __webpack_public_path__ + "static/media/HCMM740.9cffde80.jpg";